import { PageHeader } from '@folio/components';
import { DocumentsCommonListProductModule } from '@folio/modules';

export function ProductsDashboard() {
  return (
    <div>
      <PageHeader title="Produits" />
      <DocumentsCommonListProductModule />
    </div>
  );
}
